import type { NavItem } from "@voxmedia/duet-context/context/global-data-context";
import type { NavigationConfig } from "@voxmedia/duet-ui/context/component-config-context";
import { getCskDrawerNavItems } from "src/utils/csk-drawer-nav-items";

/** CSK overrides for framework navigation (comments over notifications, drawer labels). */
export const cskNavigationConfig: Partial<NavigationConfig> = {
  showNotificationsButton: false,
  getDrawerItems: (_origin: string, mainNav: NavItem[] | null) =>
    getCskDrawerNavItems(mainNav),
};
